import GenericObjectCard from './GenericObjectCard'

export default GenericObjectCard
